import { makeStyles } from '@material-ui/core'

const useStyles = makeStyles((theme) => ({
  header: {
    display: 'flex',
    alignItems: 'end',
    justifyContent: 'space-between',
    [theme.breakpoints.down('sm')]: {
      width: '100%'
    }
  },
  icon: { fontSize: 35 },
  paginationContainer: {
    display: 'flex',
    justifyContent: 'center',
    backgroundColor: theme.palette.background.default,
    marginTop: 12,
    paddingTop: 8,
    paddingBottom: 8,
    borderRadius: 12
  },
  overFlowDeskTop: {
    overflowX: 'auto',
    width: '100%',

    [theme.breakpoints.down('sm')]: {
      width: '100%'
    }
  },
  main: {
    [theme.breakpoints.between(960, 1200)]: {
      width: 0
    }
  },
  filterButton: {
    [theme.breakpoints.down('sm')]: {
      '& button': {
        '& span': {
          marginRight: 0,
          marginLeft: 0
        }
      }
    }
  },
  filterForMobileSize: {
    position: 'absolute',
    top: 160,
    width: '100%',
    left: 0,
    borderRadius: '20px 20px 0px 0px',
    bottom: 0,
    overflowY: 'auto'
  },
  filterForMobileSizeModal: {
    backgroundColor: 'transparent',
    position: 'relative'
  }
}))
export default useStyles
